export default [
  {
    title: 'Dashboard',
    route: 'v2_admin_dashboard',
    icon: 'none',
  },
  {
    title: 'Users',
    route: 'v2_userss',
    icon: 'none',
  },
]
